import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import UserProfile from '../components/Frontend/UserProfile/UserProfile';
import ChangePassword from '../components/Frontend/UserProfile/ChangePassword';
import Preference from '../components/Frontend/UserProfile/Preference';
import CompanyDetails from '../components/Frontend/UserProfile/CompanyDetails';
import BusinessSegment from '../components/Frontend/UserProfile/BusinessSegment';
import SelectCompany from '../components/Frontend/UserProfile/SelectCompany';
import { AccountListProvider } from '../context/AccountListContext';

export const userProfileRoutes = (
  <Route path="/user_profile" element={<MainLayout />}>
    <Route index path='profile' element={<UserProfile />} />
    <Route path="change_password" element={<ChangePassword />} />
    <Route path="preference" element={<Preference />} />
    
    <Route 
      path="company_profile" 
      element={
        <AccountListProvider>
          <CompanyDetails />
        </AccountListProvider>
      } 
    />
    
    <Route path="business_segment" element={<BusinessSegment />} />
    <Route path="select_company" element={<SelectCompany />} />
  </Route>
);
